enum MediaType {
  ImageGif = "image/gif",
  ImageJpeg = "image/jpeg",
  ImageJpg = "image/jpg",
  ImagePng = "image/png",
  ModelGltfBinary = "model/gltf-binary",
  TextHtml = "text/html",
  VideoMp4 = "video/mp4",
  VideoQuicktime = "video/quicktime",
}

export default MediaType;
